import { render, staticRenderFns } from "./_Page.vue?vue&type=template&id=571d1ebc&scoped=true&"
import script from "./_Page.vue?vue&type=script&lang=js&"
export * from "./_Page.vue?vue&type=script&lang=js&"
import style0 from "./_Page.vue?vue&type=style&index=0&id=571d1ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d1ebc",
  null
  
)

export default component.exports